import { DateTime } from 'luxon';
import { Reservation } from '../types';

const isBookedInternally = (
  eventStart: DateTime,
  eventEnd: DateTime,
  reservations: Reservation[]
) => {
  return reservations.some(
    (ee) =>
      DateTime.fromISO(ee.endTime) > eventStart &&
      DateTime.fromISO(ee.startTime) < eventEnd
  );
};

export default isBookedInternally;
